import React from 'react';

import ReactOtpInput from 'react-otp-input';

type OtpInputProps = {
  onChange: (opt: string) => void;
  otp: string;
};

export const OtpInput: React.FC<OtpInputProps> = ({ onChange, otp }) => {
  return (
    <ReactOtpInput
      containerStyle={{ display: 'flex', justifyContent: 'center' }}
      shouldAutoFocus={true}
      value={otp}
      inputStyle={{
        borderRadius: '5px',
        borderStyle: 'solid',
        borderWidth: '1px',
        fontSize: 'md',
        height: '40px',
        marginLeft: '4px',
        marginRight: '4px',
        width: '40px',
      }}
      onChange={onChange}
      numInputs={6}
      renderInput={(props) => {
        return <input inputMode="tel" {...props} />;
      }}
    />
  );
};
